// extracted by mini-css-extract-plugin
export default {"BrokerIdLogo":"BrokerIdLogo_BrokerIdLogo__ogK6i"};